import { EDocumentStatus, EDocumentType } from '@if/core/types';
export var EJobTypeWithUnemployed;
(function (EJobTypeWithUnemployed) {
    EJobTypeWithUnemployed[EJobTypeWithUnemployed["Unemployed"] = -1] = "Unemployed";
})(EJobTypeWithUnemployed || (EJobTypeWithUnemployed = {}));
export var EReviewLink;
(function (EReviewLink) {
    EReviewLink["Medicard"] = "https://g.page/r/CYpoFarvZlYMEBI/review";
    EReviewLink["IFinance"] = "https://g.page/r/CbeNfU0EirsoEBE/review";
    EReviewLink["IcebergFinance"] = "https://search.google.com/local/writereview?placeid=ChIJVVUlExiXuEwRkhmBY9nyimY";
})(EReviewLink || (EReviewLink = {}));
export var ESessionStorageKeys;
(function (ESessionStorageKeys) {
    ESessionStorageKeys["PREQUAL_INFO"] = "prequalInfo";
    ESessionStorageKeys["ORIGINATION"] = "origination";
    ESessionStorageKeys["COAPPLICANT_INFO"] = "coapplicantInfo";
    ESessionStorageKeys["CREDIT_APPLICATION_INFO"] = "creditApplicationInfo";
})(ESessionStorageKeys || (ESessionStorageKeys = {}));
export var ESupplementalLoanRefusalReasons;
(function (ESupplementalLoanRefusalReasons) {
    ESupplementalLoanRefusalReasons["UnderMinimalAmount"] = "UnderMinimalAmount";
    ESupplementalLoanRefusalReasons["CreditRepportExpired"] = "CreditRepportExpired";
    ESupplementalLoanRefusalReasons["DocumentsAreScanning"] = "DocumentsAreScanning";
    ESupplementalLoanRefusalReasons["OnGoingCreditApplication"] = "OnGoingCreditApplication";
})(ESupplementalLoanRefusalReasons || (ESupplementalLoanRefusalReasons = {}));
export var ExceptionErrorCode;
(function (ExceptionErrorCode) {
    ExceptionErrorCode["DuplicateException"] = "DuplicateException";
    ExceptionErrorCode["InvalidLoanPurpose"] = "InvalidLoanPurpose";
    ExceptionErrorCode["RecaptchaException"] = "RecaptchaException";
})(ExceptionErrorCode || (ExceptionErrorCode = {}));
export var EBadReviewReason;
(function (EBadReviewReason) {
    EBadReviewReason["Other"] = "OTHER";
})(EBadReviewReason || (EBadReviewReason = {}));
export const EMAIL_IFINANCE = 'app@ifinancecanada.com';
export const PHONE_NUMBER_IFINANCE = '1-888-689-9876';
export const PHONE_NUMBER_LINK_IFINANCE = `tel:${PHONE_NUMBER_IFINANCE.replace(/[- ()]/g, '')}`;
export const EMAIL_ICEBERG = 'info@icebergfinance.ca';
export const PHONE_NUMBER_ICEBERG = '1-855-694-0960';
export const PHONE_NUMBER_LINK_ICEBERG = `tel:${PHONE_NUMBER_ICEBERG.replace(/[- ()]/g, '')}`;
export const Constants = {
    PHONE_NUMBER_IFINANCE,
    PHONE_NUMBER_LINK_IFINANCE: `tel:${PHONE_NUMBER_IFINANCE.replace(/-/g, '')}`,
    PHONE_NUMBER_ICEBERG,
    PHONE_NUMBER_LINK_ICEBERG: `tel:${PHONE_NUMBER_ICEBERG.replace(/-/g, '')}`,
    SupportedDocumentTypes: '.jpg, .jpeg, .png, .pdf, .heic, .heif',
    monthNames: {
        1: { nameEn: 'January', nameFr: 'Janvier' },
        2: { nameEn: 'February', nameFr: 'Février' },
        3: { nameEn: 'March', nameFr: 'Mars' },
        4: { nameEn: 'April', nameFr: 'Avril' },
        5: { nameEn: 'May', nameFr: 'Mai' },
        6: { nameEn: 'June', nameFr: 'Juin' },
        7: { nameEn: 'July', nameFr: 'Juillet' },
        8: { nameEn: 'August', nameFr: 'Août' },
        9: { nameEn: 'September', nameFr: 'Septembre' },
        10: { nameEn: 'October', nameFr: 'Octobre' },
        11: { nameEn: 'November', nameFr: 'Novembre' },
        12: { nameEn: 'December', nameFr: 'Décembre' },
    },
    IncomeProofTypes: [
        EDocumentType.LastPayStubJob,
        EDocumentType.FamilyAllocationsProof,
        EDocumentType.WorkIncidentIndemnisationProof,
        EDocumentType.MaternityPaternityIncomeProof,
        EDocumentType.OtherIncomeProof,
        EDocumentType.RetirementIncomeProof,
        EDocumentType.DisabilityIncomeProof,
        EDocumentType.AssistanceProof,
        EDocumentType.EmployementInsuranceProof,
        EDocumentType.T4,
        EDocumentType.T4E,
        EDocumentType.NoticeOfAssessment,
        EDocumentType.ProofOfIncome,
        EDocumentType.ProofOfBenefits,
        EDocumentType.ChildTaxBenefitStatement,
        EDocumentType.MaternityLeaveBenefit,
        EDocumentType.SixMonthsPersonalBankStatements,
        EDocumentType.ThreeMonthsPersonalBankStatements,
        EDocumentType.LessThanThreeMonthsPersonalBankStatements,
        EDocumentType.VoidCheque,
    ],
    ExpectingDocumentStatuses: [EDocumentStatus.AwaitingDocument, EDocumentStatus.Incomplete, EDocumentStatus.Refused],
    MerchantsThatForbidHavingCoapplicants: ['alis*16111', 'alis*4239']
};
